import { GuestsObject } from "components/HeroSearchForm/type";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import React, { useEffect, useState } from "react";
import { FC } from "react";

export interface GuestsInputProps {
  defaultValue?: GuestsObject;
  onChange?: (data: GuestsObject) => void;
  className?: string;
}

const GuestsInput: FC<GuestsInputProps> = ({
  defaultValue,
  onChange,
  className = "",
}) => {
  const getsessionStorageValue = (key: string, defaultValue: number) => {
    const storedValue = sessionStorage.getItem(key);
    return storedValue !== null ? parseInt(storedValue, 10) : defaultValue;
  };

  const [guestAdultsInputValue, setGuestAdultsInputValue] = useState(
    getsessionStorageValue("adults_guests", defaultValue?.guestAdults || 2)
  );
  const [guestChildrenInputValue, setGuestChildrenInputValue] = useState(
    getsessionStorageValue("children_guests", defaultValue?.guestChildren || 0)
  );
  const [guestInfantsInputValue, setGuestInfantsInputValue] = useState(
    defaultValue?.guestInfants || 0
  );

  useEffect(() => {
    setGuestAdultsInputValue(
      getsessionStorageValue("adults_guests", defaultValue?.guestAdults || 2)
    );
  }, [defaultValue?.guestAdults]);

  useEffect(() => {
    setGuestChildrenInputValue(
      getsessionStorageValue("children_guests", defaultValue?.guestChildren || 0)
    );
  }, [defaultValue?.guestChildren]);

  useEffect(() => {
    setGuestInfantsInputValue(defaultValue?.guestInfants || 0);
  }, [defaultValue?.guestInfants]);

  const updatesessionStorage = (adults: number, children: number) => {
    sessionStorage.setItem("adults_guests", String(adults));
    sessionStorage.setItem("children_guests", String(children));
    sessionStorage.setItem("total_disp", String(adults + children));
    sessionStorage.setItem("total_guests", String(adults + children));
  };

  useEffect(() => {
    updatesessionStorage(guestAdultsInputValue, guestChildrenInputValue);
  }, [guestAdultsInputValue, guestChildrenInputValue]);

  const handleChangeData = (value: number, type: keyof GuestsObject) => {
    let newValue = {
      guestAdults: guestAdultsInputValue,
      guestChildren: guestChildrenInputValue,
      guestInfants: guestInfantsInputValue,
    };
    if (type === "guestAdults") {
      setGuestAdultsInputValue(value);
      newValue.guestAdults = value;
    }
    if (type === "guestChildren") {
      setGuestChildrenInputValue(value);
      newValue.guestChildren = value;
    }
    if (type === "guestInfants") {
      setGuestInfantsInputValue(value);
      newValue.guestInfants = value;
    }
    onChange && onChange(newValue);
    updatesessionStorage(newValue.guestAdults, newValue.guestChildren);
  };

  return (
    <div className={`flex flex-col relative p-5 ${className}`}>
      <span className="mb-5 block font-semibold text-xl sm:text-2xl">
        {`¿Cuántas personas?`}
      </span>
      <NcInputNumber
        className="w-full"
        defaultValue={guestAdultsInputValue}
        onChange={(value) => handleChangeData(value, "guestAdults")}
        max={20}
        label="Adultos"
        desc="Más de 12 años"
      />
      <NcInputNumber
        className="w-full mt-6"
        defaultValue={guestChildrenInputValue}
        onChange={(value) => handleChangeData(value, "guestChildren")}
        max={20}
        label="Niños"
        desc="Edad 4–11 años"
      />

      {/* <NcInputNumber
        className="w-full mt-6"
        defaultValue={guestInfantsInputValue}
        onChange={(value) => handleChangeData(value, "guestInfants")}
        max={20}
        label="Bebés"
        desc="Edad 0–2 años"
      /> */}
    </div>
  );
};

export default GuestsInput;